import { gql } from '@apollo/client';

export const FETCH_CONVERSATIONS_LIST_WEB = gql`
  query FetchConversationsList(
    $cursor: String
    $pageSize: Int
    $causeId: String!
    $sortType: String
    $userId: String
  ) {
    conversationsList(
      cursor: $cursor
      pageSize: $pageSize
      causeId: $causeId
      sortType: $sortType
      userId: $userId
    ) {
      id
      nextCursor
      entries {
        id
        title
        heroImageUrl
        numVotes
        createdAt
        message
        numComments
        deletedAt
        isAnonymous
        user {
          id
          username
          profilePhoto
          school {
            id
            name
          }
        }
        cause {
          id
          name
          moderators {
            id
            username
            fullName
            profilePhoto
          }
        }
      }
    }
  }
`;
